import { API_ENDPOINT } from '../config';
import { parseCookie } from './utils';

export default function(performanceId, tickets, name, email, phone) {
    return fetch(`${API_ENDPOINT}/performances/${performanceId}/book/`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, tickets, name, phone, uid: getUidFromCookie() })
    });
}

function getUidFromCookie() {
    const parsed_cookie = parseCookie()
    const uid = parsed_cookie.uid
    if(uid) return uid
    else return null
}
